// WebChat configuration shared across components
export const WEBCHAT_CONFIG = {
    headerTitle: "M Lijo",
    clientLogo: "https://versal.one/assets/images/favicon.png",
    clientName: "M Lijo",
    contactDetails: "For any queries regarding customisation of your report contact us at info@infiniumglobalresearch.com",
    chatPoweredBy: "⚡Powered by Infinium",
    PoweredBy: "IGR-Infi-Portal",
    Language: "EN",
    clientId: "62b58b1d-4698-4d92-b29a-fe113c7b0310",
    uuid: "62b58b1d-4698-4d92-b29a-fe113c7b0310",
    webhookId: "a25ec701-bfa9-4836-a880-23d196c3e8b9",
    ServerURL: "https://chatapp.versalence.online",
};

export const CHAT_AUTH_TOKEN = process.env.REACT_APP_CHAT_AUTH_TOKEN || "";

export const CHAT_API_BASE = "https://chat.versalence.info/webchat/v2";
export const CHAT_HISTORY_API_BASE = "https://chat.versalence.info/whatsapp/v2/chat";
